// state
const state = () => ({
  loading: false,
  loadingEmpresa: false,
  loadingResultadosChamadas: 0,
  loadingPesquisaNcm: false,
  loadingImpressao: false,
  blBigData: false,
  loadingCargaLiquida: false,
  loadingTributos: [],
  loadingResultado: false,
});

// getters
const getters = {
  getLoading: (state) => {
    return state.loading;
  },
  getBlBigData: (state) => {
    return state.blBigData;
  },
  getLoadingEmpresa: (state) => {
    return state.loadingEmpresa
  },
  getLoadingResultadosChamadas: (state) => {
    return state.loadingResultadosChamadas
  },
  getLoadingPesquisaNcm: (state) => {
    return state.loadingPesquisaNcm
  },
  getLoadingImpressao: (state) => {
    return state.loadingImpressao
  },
  getLoadingCargaLiquida: (state) => {
    return state.loadingCargaLiquida
  },
  getLoadingTributos: (state) => {
    return state.loadingTributos
  },
  getLoadingResultado: (state) => {
    return state.loadingResultado
  }
};

// mutations
const mutations = {
  SET_LOADING (state, loading) {
    state.loading = loading
  },
  SET_BL_BIG_DATA(state, blBigData) {
    state.blBigData = blBigData;
  },
  SET_LOADING_EMPRESA (state, loadingEmpresa) {
    state.loadingEmpresa = loadingEmpresa
  },
  ADD_LOADING_RESULTADOS_CHAMADAS (state) {
    state.loadingResultadosChamadas++;
  },
  REM_LOADING_RESULTADOS_CHAMADAS (state) {
    state.loadingResultadosChamadas--;
  },
  RESET_LOADING_RESULTADOS_CHAMADAS (state) {
    state.loadingResultadosChamadas = 0;
  },
  SET_LOADING_PESQUISA_NCM (state, loadingPesquisaNcm) {
    state.loadingPesquisaNcm = loadingPesquisaNcm
  },
  SET_LOADING_IMPRESSAO (state, loadingImpressao) {
    state.loadingImpressao = loadingImpressao
  },
  SET_LOADING_CARGA_LIQUIDA (state, loadingCargaLiquida) {
    state.loadingCargaLiquida = loadingCargaLiquida
  },
  SET_LOADING_TRIBUTOS (state, loadingTributos) {
    state.loadingTributos = loadingTributos
  },
  SET_LOADING_RESULTADO (state, loadingResultado) {
    state.loadingResultado = loadingResultado
  }
}

// actions
const actions = {
  setLoading ({ commit }, loading) {
    commit('SET_LOADING', loading)
  },
  setBlBigData({ commit }, blBigData) {
    commit('SET_BL_BIG_DATA', blBigData);
  },
  setLoadingEmpresa ({ commit }, loadingEmpresa) {
    commit('SET_LOADING_EMPRESA', loadingEmpresa)
  },
  addLoadingResultadosChamadas ({ commit }) {
    commit('ADD_LOADING_RESULTADOS_CHAMADAS')
  },
  remLoadingResultadosChamadas ({ commit }) {
    commit('REM_LOADING_RESULTADOS_CHAMADAS')
  },
  resetLoadingResultadosChamadas ({ commit }) {
    commit('RESET_LOADING_RESULTADOS_CHAMADAS')
  },
  setLoadingPesquisaNcm ({ commit }, loadingPesquisaNcm) {
    commit('SET_LOADING_PESQUISA_NCM', loadingPesquisaNcm)
  },
  setLoadingImpressao ({ commit }, loadingImpressao) {
    commit('SET_LOADING_IMPRESSAO', loadingImpressao)
  },
  setLoadingCargaLiquida ({ commit }, loadingCargaLiquida) {
    commit('SET_LOADING_CARGA_LIQUIDA', loadingCargaLiquida)
  },
  setLoadingTributos ({ commit, state }, { id, aba, classe, loading }) {
    let loadingTributos = state.loadingTributos

    loadingTributos = loadingTributos.filter(load => {
      if (!load) { return false }
      if (load.id != id && load.aba != aba && load.classe != classe) { return true }
      return false
    })

    loadingTributos.push({ id, aba, classe, loading })
    
    commit('SET_LOADING_TRIBUTOS', loadingTributos)
  },
  setLoadingResultado ({ commit }, loadingResultado) {
    commit('SET_LOADING_RESULTADO', loadingResultado)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
